(function () {

  /* ─── Shared state ─────────────────────────────────────────────────────── */

  var activeCompare = null;

  function updateSplit(container, clientX) {
    var rect = container.getBoundingClientRect();
    var pct  = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    container.style.setProperty('--split', pct + '%');
  }

  window.addEventListener('mousemove', function (e) {
    if (activeCompare) updateSplit(activeCompare, e.clientX);
  });
  window.addEventListener('mouseup',   function ()  { activeCompare = null; });

  window.addEventListener('touchmove', function (e) {
    if (activeCompare) updateSplit(activeCompare, e.touches[0].clientX);
  }, { passive: true });
  window.addEventListener('touchend',  function ()  { activeCompare = null; });

  /* ─── Drag init for any compare container ──────────────────────────────── */

  function initCompareDrag(container) {
    container.addEventListener('mousedown', function (e) {
      activeCompare = container;
      updateSplit(container, e.clientX);
      e.preventDefault();
      e.stopPropagation(); // prevent the product slider from intercepting
    });

    container.addEventListener('touchstart', function (e) {
      activeCompare = container;
      updateSplit(container, e.touches[0].clientX);
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  }

  /* ─── Section resultats-2 ──────────────────────────────────────────────── */

  function initCompare() {
    document.querySelectorAll('.resultats__compare').forEach(function (container) {
      if (container.dataset.compareInit) return;
      container.dataset.compareInit = '1';
      initCompareDrag(container);
    });
  }

  /* ─── Product slider ───────────────────────────────────────────────────── */

  var HANDLE_SVG = [
    '<div class="resultats__compare-circle">',
      '<svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">',
        '<path d="M7 1L1 7L7 13" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
        '<path d="M15 1L21 7L15 13" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>',
    '</div>'
  ].join('');

  function buildWidget(beforeImg, afterImg) {
    var widget = document.createElement('div');
    widget.className = 'resultats__compare';
    widget.style.setProperty('--split', '50%');

    // Before image becomes the base layer (sets height of widget)
    beforeImg.classList.add('resultats__compare-img', 'resultats__compare-img--avant');
    widget.appendChild(beforeImg);

    // After image becomes the clipped overlay
    afterImg.classList.add('resultats__compare-img', 'resultats__compare-img--apres');
    widget.appendChild(afterImg);

    // Handle bar + circle
    var handle = document.createElement('div');
    handle.className = 'resultats__compare-handle';
    handle.innerHTML = HANDLE_SVG;
    widget.appendChild(handle);

    // Avant / Après labels
    // var labels = document.createElement('div');
    // labels.className = 'resultats__compare-labels';
    // labels.innerHTML = [
    //   '<span class="resultats__compare-label">Avant</span>',
    //   '<span class="resultats__compare-label">Après</span>'
    // ].join('');
    // widget.appendChild(labels);

    return widget;
  }

  function initProductCompare() {
    document.querySelectorAll('product-medias-slider').forEach(function (sliderEl) {
      if (sliderEl.dataset.compareInit) return;

      var beforeSlide = null;
      var afterSlide  = null;

      sliderEl.querySelectorAll('.product-medias__slide').forEach(function (slide) {
        var img = slide.querySelector('.product-medias__slide-img');
        if (!img) return;
        var alt = (img.alt || '').toLowerCase().trim();
        if (alt === 'before') beforeSlide = slide;
        if (alt === 'after')  afterSlide  = slide;
      });

      if (!beforeSlide || !afterSlide) return;

      sliderEl.dataset.compareInit = '1';

      var beforeImg = beforeSlide.querySelector('.product-medias__slide-img');
      var afterImg  = afterSlide.querySelector('.product-medias__slide-img');

      // Remove the "after" thumbnail — it will be redundant
      var afterId    = afterSlide.dataset.slide;
      var afterThumb = sliderEl.querySelector('.product-medias__thumbnail[data-thumbnail="' + afterId + '"]');

      // Build widget and inject into the "before" slide
      var widget = buildWidget(beforeImg, afterImg);
      beforeSlide.appendChild(widget);

      // Clean up "after" slide & thumbnail
      afterSlide.style.display = 'none';
      if (afterThumb) afterThumb.remove();

      initCompareDrag(widget);
    });
  }

  function setupProductCompare() {
    if (!document.querySelector('product-medias-slider')) return;

    if (window.customElements) {
      // Resolves once product-medias.js has run customElements.define()
      // At that point connectedCallback has already fired, slider is ready
      customElements.whenDefined('product-medias-slider').then(function () {
        requestAnimationFrame(initProductCompare);
      });
    } else {
      initProductCompare();
    }
  }

  /* ─── Boot ─────────────────────────────────────────────────────────────── */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCompare();
      setupProductCompare();
    });
  } else {
    initCompare();
    setupProductCompare();
  }

})();
